import React from 'react';
import { motion } from 'framer-motion';
import { SailboatIcon, UsersIcon, GraduationCapIcon } from 'lucide-react';
interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  delay: number;
}
function FeatureCard({
  icon,
  title,
  description,
  delay
}: FeatureCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.8,
    delay
  }} className="bg-off-white rounded-xl p-8 border border-mist/50 hover:shadow-md transition-shadow duration-300" data-id="element-92">
      <div className="w-14 h-14 rounded-full bg-white shadow-sm flex items-center justify-center mb-6 text-blue-medium" data-id="element-93">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-navy-deep mb-3" data-id="element-94">{title}</h3>
      <p className="text-navy-deep/70 leading-relaxed text-sm md:text-base" data-id="element-95">
        {description}
      </p>
    </motion.div>;
}
export function Features() {
  const teamLogos = [{
    src: 'https://cdn.magicpatterns.com/uploads/h114Kp6iFiEvMHjhcMVAbc/AirYachtTeam.svg',
    alt: 'Air Yacht Team'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ohT1kyd8pfi1zeadkMrTKV/Amaters.svg',
    alt: 'Amaters'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/vMcj1SYPuRqgF1MaV3fEhJ/DeepHope.svg',
    alt: 'Deep Hope'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/dzz5jr9hNrRMTNoN9B5ajU/SailLaVie.svg',
    alt: 'Sail La Vie'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/w9jVp8ysHzTGam9SmmNJhP/SeaStars.svg',
    alt: 'Sea Stars'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/1E9yVuBfsEBmwBJuV823Q8/DeltaSailingTeam.svg',
    alt: 'Delta Sailing Team'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/1PcvHhWkcU9w9uGqjrc5ij/SailingSealsII.svg',
    alt: 'Sailing Seals II'
  }];
  return <section className="w-full bg-white py-24 px-6" data-id="element-96">
      <div className="max-w-6xl mx-auto" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-98">
          <h2 className="text-[48px] font-[200] text-navy-deep mb-4" data-id="element-99">
            Filozofie akce
          </h2>
          <div className="w-24 h-1 bg-blue-medium mx-auto rounded-full opacity-50" data-id="element-100" />
        </motion.div>

        <div className="mb-20 space-y-12" data-id="element-101">
          <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20" data-id="element-102">
            {teamLogos.slice(0, 4).map((logo, i) => <motion.img key={i} src={logo.src} alt={logo.alt} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 0.3
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: i * 0.1
          }} className="h-14 md:h-20 w-auto grayscale brightness-0 opacity-30 object-contain" data-id="element-103" />)}
          </div>
          <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20" data-id="element-104">
            {teamLogos.slice(4).map((logo, i) => <motion.img key={i} src={logo.src} alt={logo.alt} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 0.3
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            delay: (i + 4) * 0.1
          }} className="h-14 md:h-20 w-auto grayscale brightness-0 opacity-30 object-contain" data-id="element-105" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-106">
          <FeatureCard icon={<SailboatIcon className="w-7 h-7" data-id="element-108" />} title="Více plachtění" description="Zásadně prodloužit dobu plachtění v rámci výzvy a zkrátit čekání u mola v maríně. Zvýšit počet rozjížděk a zjednodušit celkovou organizaci." delay={0} data-id="element-107" />
          <FeatureCard icon={<UsersIcon className="w-7 h-7" data-id="element-110" />} title="Rekreační posádky" description="Garantovat účast pouze rekreačních posádek. Každá loď se stává partnerem akce – pokud může přispět k zážitku, který si děláme pro sebe, je to super." delay={0.2} data-id="element-109" />
          <FeatureCard icon={<GraduationCapIcon className="w-7 h-7" data-id="element-112" />} title="Rozvoj dovedností" description="Přispět k vyšší úrovni znalostí v oblasti ovládání lodě v přístavu i na moři. Zvýšit úroveň bezpečnější plavby s důrazem na respektování pravidel." delay={0.4} data-id="element-111" />
        </div>
      </div>
    </section>;
}